module.exports = __webpack_public_path__ + "img/header-bg.694a2796.png";